import React, { useEffect, useState } from 'react'
import Footer from '../../../Components/Footer'
import Header from '../../../Components/Header'
import { BrowserView, MobileView } from 'react-device-detect'
import { Link, Outlet, useNavigate, useParams } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { ApiService } from '../../../Components/Services/apiServices'
import AccountSidebar from '../AccountSidebar'
import { FaDirections, FaPhone, FaQuestionCircle } from 'react-icons/fa';

const BookingDetail = () => {

    const [userDetails, setUserDetails] = useState(null);
    const [bookings, setBookings] = useState("");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const { bookingId } = useParams();
    const getFormattedDate = (dateString) => {
        const date = new Date(dateString);
        const options = { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };


    useEffect(() => {


        fetchBookings(bookingId);

    }, [bookingId]);




    const fetchBookings = async (bookingId) => {
        setLoading(true);
        try {
            const response = await ApiService.Commanfetchrequest(`booking/${bookingId}`);
            console.log(response)
            setBookings(response.booking);
            setUserDetails(response.user);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('Error fetching bookings:', error);
        }
    };


    const handleCancelBooking = async () => {
        if (window.confirm("Are you sure you want to cancel this booking?")) {
            try {
                const response = await ApiService.Commanpostrequest(`cancel-booking/${bookingId}`, { bookingId });

                if (response.message) {
                    // alert("Booking canceled successfully");
                    navigate(`/cancel-booking/${bookingId}`);
                } else {
                    alert("Failed to cancel booking. Please try again.");
                }
            } catch (error) {
                console.log("Error while canceling booking:", error);
                alert("An error occurred. Please try again.");
            }
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!bookings) {
        return (
            <div className="container py-5">
                <h3 className="text-center">No bookings found</h3>
            </div>
        );
    }


    return (
        <>
            <Header />
            <BrowserView>
                <div className="account-container">
                    <AccountSidebar />
                    <div className="account-content container py-5">
                        <div className="container">
                            <h5 className="text-center text-primary mb-4">Your Booking Details</h5>

                            {/* Room Name and Address */}
                            <div className="row mb-5">
                                <div className="col-12 col-md-6">
                                    <h4 style={{ fontWeight: "700" }}>WeJai</h4>
                                    <p>{bookings.room_name}</p>
                                    <p>Pratap Nagar, Sect-9, Jaipur-302033</p>
                                </div>
                            </div>

                            {/* Icons Section */}
                            <div className="row text-center mb-5">
                                <div className="col-4">
                                    <FaDirections size={30} />
                                    <p>Directions</p>
                                </div>
                                <div className="col-4">
                                    <FaPhone size={30} />
                                    <p>Call Hotel</p>
                                </div>
                                <div className="col-4">
                                    <FaQuestionCircle size={30} />
                                    <p>Need Help</p>
                                </div>
                            </div>

                            {/* Dates */}
                            <div className="row mb-5">
                                <div className="col-6">
                                    <p style={{ fontWeight: "700" }}>Check-in Date:</p>
                                    <p>{getFormattedDate(bookings.check_in)}</p>
                                    <p style={{ fontSize: "12px" }}>12:00 PM onward</p>
                                </div>
                                <div className="col-6">
                                    <p style={{ fontWeight: "700" }}>Check-out Date:</p>
                                    <p>{getFormattedDate(bookings.check_out)}</p>
                                    <p style={{ fontSize: "12px" }}>Before 11:00 AM</p>
                                </div>
                            </div>


                            {/* Booking ID */}
                            <div className="mb-2">
                                <p style={{ fontWeight: "700" }}>Booking ID: <span style={{ fontWeight: "400" }}>{bookings?.booking_id}</span></p>
                            </div>

                            <p><strong>Status: </strong>
                                <span className={`badge ${bookings.status === 1 ? "bg-success" : "bg-danger"}`}>
                                    {bookings.status === 1 ? "Booked" : "Cancelled"}
                                </span>
                            </p>


                            {bookings.status === 1 ? (
                                <div className="mb-2">
                                    <p><strong>Stay: </strong>
                                        <span className={`badge ${new Date() > new Date(bookings.check_out) ? "bg-success" : "bg-warning"}`}
                                            style={{ fontWeight: "700", padding: "5px 10px", borderRadius: "5px" }}>
                                            {new Date() > new Date(bookings.check_out) ? "Completed" : "In Process"}
                                        </span>
                                    </p>
                                </div>
                            ) : (
                                ""
                            )}



                            {/* Reserved for */}
                            <div className="row mb-5">
                                <div className="col-12 col-md-6">
                                    <p style={{ fontWeight: "700" }}>Reserved For:  <span style={{ fontWeight: "400" }}>{userDetails.full_name}</span></p>
                                    <p style={{ fontWeight: "700" }}>Room: <span style={{ fontWeight: "400" }}>{bookings.rooms} Room(s)</span></p>
                                    <p style={{ fontWeight: "700" }}>Guests: <span style={{ fontWeight: "400" }}>{bookings.guests} Guest(s)</span></p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <p style={{ fontWeight: "700" }}>Contact Information:</p>
                                    <p>{userDetails.email}</p>
                                    <p>{userDetails.mobile}</p>
                                </div>
                            </div>

                            {/* Important Notes */}
                            <div className="row mb-2">
                                <div className="col-12">
                                    <h6 style={{ fontWeight: "700" }}>Important to Note:</h6>
                                    <div className="row mb-5">
                                        <div className="col-6">
                                            <p>Check-in:</p>
                                            <p style={{ fontSize: "12px" }}>12:00 PM</p>
                                        </div>
                                        <div className="col-6">
                                            <p>Check-out</p>
                                            <p style={{ fontSize: "12px" }}>Till 11:00 AM</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-5">
                                <div className="col-12">
                                    <h6 style={{ fontWeight: "700" }}>Rules & Restrictions:</h6>
                                    <ul style={{ paddingLeft: "20px" }}>
                                        <li>Couples are welcome</li>
                                        <li>Guests can check in using any local or outstanding ID proof (PAN card not accepted).</li>
                                        <li>Check-in time: 12:00 PM onward</li>
                                        <li>Check-out time: Before 11:00 AM</li>
                                    </ul>
                                    <Link to="#">View guest policy</Link>
                                </div>
                            </div>


                            {/* Cancel Booking Button */}
                            {bookings.status === 0 ? (
                                <button className="btn btn-warning">Book Again</button>
                            ) : (
                                new Date() <= new Date(bookings.check_out) && (
                                    <button className="btn btn-danger" onClick={handleCancelBooking}>Cancel Booking</button>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div className="account-container">
                    <div className="account-content container py-5">
                        <div className="container">
                            <h5 className="text-center text-primary mb-4">Your Booking Details</h5>

                            {/* Room Name and Address */}
                            <div className="row mb-5">
                                <div className="col-12 col-md-6">
                                    <h4 style={{ fontWeight: "700" }}>WeJai</h4>
                                    <p>{bookings.room_name}</p>
                                    <p>Pratap Nagar, Sect-9, Jaipur-302033</p>
                                </div>
                            </div>

                            {/* Icons Section */}
                            <div className="row text-center mb-5">
                                <div className="col-4">
                                    <FaDirections size={30} />
                                    <p>Directions</p>
                                </div>
                                <div className="col-4">
                                    <FaPhone size={30} />
                                    <p>Call Hotel</p>
                                </div>
                                <div className="col-4">
                                    <FaQuestionCircle size={30} />
                                    <p>Need Help</p>
                                </div>
                            </div>

                            {/* Dates */}
                            <div className="row mb-5">
                                <div className="col-6">
                                    <p style={{ fontWeight: "700" }}>Check-in Date:</p>
                                    <p>{getFormattedDate(bookings.check_in)}</p>
                                    <p style={{ fontSize: "12px" }}>12:00 PM onward</p>
                                </div>
                                <div className="col-6">
                                    <p style={{ fontWeight: "700" }}>Check-out Date:</p>
                                    <p>{getFormattedDate(bookings.check_out)}</p>
                                    <p style={{ fontSize: "12px" }}>Before 11:00 AM</p>
                                </div>
                            </div>


                            {/* Booking ID */}
                            <div className="mb-2">
                                <p style={{ fontWeight: "700" }}>Booking ID: <span style={{ fontWeight: "400" }}>{bookings?.booking_id}</span></p>
                            </div>

                            <p><strong>Status: </strong>
                                <span className={`badge ${bookings.status === 1 ? "bg-success" : "bg-danger"}`}>
                                    {bookings.status === 1 ? "Booked" : "Cancelled"}
                                </span>
                            </p>


                            {bookings.status === 1 ? (
                                <div className="mb-2">
                                    <p><strong>Stay: </strong>
                                        <span className={`badge ${new Date() > new Date(bookings.check_out) ? "bg-success" : "bg-warning"}`}
                                            style={{ fontWeight: "700", padding: "5px 10px", borderRadius: "5px" }}>
                                            {new Date() > new Date(bookings.check_out) ? "Completed" : "In Process"}
                                        </span>
                                    </p>
                                </div>
                            ) : (
                                ""
                            )}



                            {/* Reserved for */}
                            <div className="row mb-5">
                                <div className="col-12 col-md-6">
                                    <p style={{ fontWeight: "700" }}>Reserved For:  <span style={{ fontWeight: "400" }}>{userDetails.full_name}</span></p>
                                    <p style={{ fontWeight: "700" }}>Room: <span style={{ fontWeight: "400" }}>{bookings.rooms} Room(s)</span></p>
                                    <p style={{ fontWeight: "700" }}>Guests: <span style={{ fontWeight: "400" }}>{bookings.guests} Guest(s)</span></p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <p style={{ fontWeight: "700" }}>Contact Information:</p>
                                    <p>{userDetails.email}</p>
                                    <p>{userDetails.mobile}</p>
                                </div>
                            </div>

                            {/* Important Notes */}
                            <div className="row mb-2">
                                <div className="col-12">
                                    <h6 style={{ fontWeight: "700" }}>Important to Note:</h6>
                                    <div className="row mb-5">
                                        <div className="col-6">
                                            <p>Check-in:</p>
                                            <p style={{ fontSize: "12px" }}>12:00 PM</p>
                                        </div>
                                        <div className="col-6">
                                            <p>Check-out</p>
                                            <p style={{ fontSize: "12px" }}>Till 11:00 AM</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-5">
                                <div className="col-12">
                                    <h6 style={{ fontWeight: "700" }}>Rules & Restrictions:</h6>
                                    <ul style={{ paddingLeft: "20px" }}>
                                        <li>Couples are welcome</li>
                                        <li>Guests can check in using any local or outstanding ID proof (PAN card not accepted).</li>
                                        <li>Check-in time: 12:00 PM onward</li>
                                        <li>Check-out time: Before 11:00 AM</li>
                                    </ul>
                                    <Link to="#">View guest policy</Link>
                                </div>
                            </div>


                            {/* Cancel Booking Button */}
                            {bookings.status === 0 ? (
                                <button className="btn btn-warning">Book Again</button>
                            ) : (
                                new Date() <= new Date(bookings.check_out) && (
                                    <button className="btn btn-danger" onClick={handleCancelBooking}>Cancel Booking</button>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </MobileView>



            {/* <Footer /> */}
        </>
    )
}

export default BookingDetail
